import React, { useEffect, useState, useMemo, useRef } from "react";
import axios from "axios";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Wallet from "../shared/wallet/Wallet";
import JoditEditor from "jodit-react";
import { BigNumber } from "@ethersproject/bignumber";
import { useDispatch, useSelector } from "react-redux";
import { ethers } from "ethers";
import mrsabi from "../abi/mrsabi.json";
import convert from "ethereum-unit-converter";
import { SpinningCircles } from "react-loading-icons";
import { AiOutlinePlus, AiOutlineMinus, AiOutlineClose } from "react-icons/ai";
import { updateUserInfo } from "../actions/updateUsers";
import { btnResolver, waitForPress } from "../actions/sign";
import { walletopen, signpageopen, signpageclose } from "../reducers/wallet";

function Suggestions() {
  const dispatch = useDispatch();
  const contractAddress = "0x2f8B8B239C89588d46b83Ad2fAA7CA7B3AB476f0";

  let tempProvider = new ethers.providers.Web3Provider(window.ethereum);
  let tempSigner = tempProvider.getSigner();
  let tempContract = new ethers.Contract(contractAddress, mrsabi, tempSigner);

  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [posts, changePosts] = useState([]);
  const [stake, changeStake] = useState("0.0000000");
  const [wei, updatewei] = useState(0);
  const config = {
    readonly: false,
    height: 200,
  };

  const address = useSelector((state) => state.user.address);
  const uname = useSelector((state) => state.user.username);

  const storyID =
    window.location.href.split("/")[window.location.href.split("/").length - 1];

  const [story, changeStory] = useState({});
  const [suggestions, changeSuggestions] = useState([]);
  const [expanded, changeExpanded] = useState([]);
  const [voteStake, alterVoteStake] = useState(0.0);
  const [voteSuggestionID, alterVoteSuggestionID] = useState("");
  const [showDialog, changeShowDialog] = useState(false);
  const wallet = useSelector((state) => state.wallet);

  useEffect(() => {
    const storyID =
      window.location.href.split("/")[
        window.location.href.split("/").length - 1
      ];

    const loadStory = async () => {
      try {
        const currStory = await axios.get(
          `https://floating-dusk-30317.herokuapp.com/api/v1/stories/getStoryByID/${storyID}`
        );
        changeStory(currStory.data);
        console.log(currStory.data);
      } catch (error) {
        console.log(error);
        alert("Server error");
      }
    };

    loadStory();

    const loadSuggestions = async () => {
      try {
        const currStory = await axios.get(
          `https://floating-dusk-30317.herokuapp.com/api/v1/suggestions/getAllSuggestions/${storyID}`
        );
        changeSuggestions(currStory.data);

        //initialize expanded array
        let tempArr = new Array(currStory.data.length).fill(false);
        changeExpanded(tempArr);

        console.log(currStory.data);
      } catch (error) {
        console.log(error);
        alert("Server error");
      }
    };
    loadSuggestions();
  }, [wallet]);

  const handleUpdate = (e) => {
    const editorContent = e;
    setContent(editorContent);
    // console.log(content);
  };

  const alterStake = (e) => {
    changeStake(e.target.value);
    updatewei(convert(e.target.value, "ether", "wei"));
    // console.log(stake);
  };

  const publish = async () => {
    if (stake > 10.0 || stake < 0.0) {
      return alert("Stake value is out of limit");
    }

    dispatch(walletopen());
    console.log("entered");
    dispatch(signpageopen(stake));

    await waitForPress();

    console.log("exited");
    dispatch(signpageclose());

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const body = {
        uname: uname,
        storyID: storyID,
        content: content,
        stakedMRS: stake,
      };

      const res = await axios.post(
        "https://floating-dusk-30317.herokuapp.com/api/v1/suggestions/createSuggestion",
        body,
        config
      );

      const newSuggestion = res.data;
      changeSuggestions([...suggestions, newSuggestion]);

      updateUserInfo(address);
      alert("success");
    } catch (error) {
      console.log(error);
    }
  };

  const likeHandler = async (e) => {
    const id = e.target.id.toString();
    console.log(id);
    for (let i = 0; i < posts.length; i++) {
      if (posts[i]._id === id) {
        console.log(id);
        //increment likes
        try {
          const tx = await tempContract.functions.transfer(
            "0x8522251E68f698c72bF146E208E6d0889dC8adD2",
            "500000000000000"
          );
          console.log("success");
        } catch (error) {
          console.log(error);
        }
        const newLikes = posts[i].likes++;
        const newArr = posts.map((post) => {
          return post._id === id ? { ...post, likes: 1 } : post;
        });
        console.log(newArr);
        changePosts([...newArr]);
      }
    }
  };

  const expansionHandler = (e, index) => {
    let tempArr = [...expanded];

    tempArr[index] = !tempArr[index];

    changeExpanded(tempArr);
  };

  const postComment = async (e, id) => {
    let comment = e.target.previousSibling.value;

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const body = {
        uname: uname,
        content: comment,
        suggestionID: id,
      };

      const res = await axios.post(
        "https://floating-dusk-30317.herokuapp.com/api/v1/comments/createComment",
        body,
        config
      );
      alert("success");
      //add it to the state

      let tempArr = [...suggestions];

      tempArr = tempArr.map((element) => {
        if (element._id === id) {
          //append comment
          element.comments.push(body);
          return element;
        } else {
          return element;
        }
      });

      changeSuggestions(tempArr);

      //clear the textarea
      e.target.previousSibling.value = "";
    } catch (error) {
      console.log(error);
      alert("server error");
    }
  };

  const alterVoteStakeHandler = (e) => {
    alterVoteStake(e.target.value);
  };

  const voteHandler = (e, id) => {
    alterVoteSuggestionID(id);
    changeShowDialog(true);
  };

  const closeDialogHandler = () => {
    changeShowDialog(false);
  };

  const finalVoting = async () => {
    changeShowDialog(false);

    dispatch(walletopen());
    console.log("entered");
    dispatch(signpageopen(voteStake));

    await waitForPress();

    console.log("exited");
    dispatch(signpageclose());

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      let body = {
        uname: uname,
        suggestionID: voteSuggestionID,
        stakedMRS: voteStake,
      };

      const res = await axios.post(
        "https://floating-dusk-30317.herokuapp.com/api/v1/votes/addVote",
        body,
        config
      );
      alert("Success!");

      try {
        const currStory = await axios.get(
          `https://floating-dusk-30317.herokuapp.com/api/v1/suggestions/getAllSuggestions/${storyID}`
        );
        changeSuggestions(currStory.data);

        //initialize expanded array
        let tempArr = new Array(currStory.data.length).fill(false);
        changeExpanded(tempArr);

        console.log(currStory.data);
      } catch (error) {
        console.log(error);
        alert("Server error");
      }

      updateUserInfo(address);
    } catch (error) {
      console.log(error);
    }
  };

  // let waitForPressResolve;

  // function waitForPress() {
  //   return new Promise(resolve => waitForPressResolve = resolve);
  // }

  // function btnResolver() {
  //   if(waitForPressResolve) waitForPressResolve()
  // }

  return (
    <div className="relative z-0 ">
      {/* <button className="bg-black text-white" onClick={btnResolver}>Promise</button> */}
      {showDialog && (
        <div className="fixed w-full h-screen top-0 left-0 z-50 flex flex-col backdrop-blur-sm bg-black-rgba justify-center">
          <div className="my-0 mx-auto bg-white w-full rounded-xl w-96 h-72 p-8 flex flex-col space-y-8 max-w-3xl justify-start">
            <div
              onClick={closeDialogHandler}
              className="font-2xl cursor-pointer"
            >
              <AiOutlineClose />
            </div>
            <h2 className="font-xl bold text-left">
              Select MRS token to stake for this vote
            </h2>
            <input
              className="border p-4 border-black rounded-xl"
              type="number"
              step="0.0000001"
              onChange={(e) => alterVoteStakeHandler(e)}
              value={voteStake}
            />
            <button
              onClick={finalVoting}
              className="bg-blue-500 px-8 py-2 text-white rounded-2xl"
            >
              Stake and Vote
            </button>
          </div>
        </div>
      )}

      <Navbar />
      <div className="flex flex-row justify-between">
        <div className="my-4">
          <Sidebar />
        </div>

        <div className="m-4 w-[50rem]">
          <h2 className="mb-4 text-2xl text-left font-alata">
            Minerpets World &gt; Main Story &gt; Part I
          </h2>

          {story ? (
            <div className="px-8 py-8 mb-4 text-left bg-[#f5f5f5]">
              {story.content}
            </div>
          ) : (
            <div className="flex justify-center items-center w-full h-96">
              <SpinningCircles fill="#000" />
            </div>
          )}

          <h1 className="text-2xl mt-8 mb-8 text-left font-alata">Posts</h1>

          <hr className="border-1 border-black my-8"></hr>

          {suggestions ? (
            suggestions.map((post, index) => {
              return (
                <div key={post._id} className="flex flex-col my-8 ">
                  <div className="px-8 rounded-t-md shadow-md py-8 text-left bg-[#f5f5f5]">
                    <div className="flex flex-row mb-8 items-center">
                      <div className="bg-blue-500 rounded-full w-8 h-8"></div>
                      <p className="text-base ml-4">{post.uname}</p>
                    </div>

                    <div
                      className=""
                      dangerouslySetInnerHTML={{ __html: post.content }}
                    ></div>

                    <div className="mt-8 mb-4 flex flex-row flex-wrap space-x-4 items-center">
                      <div className="flex flex-col space-y-1 items-center">
                        <div className="py-2 px-4 bg-[#FFE999] rounded-xl">
                          <p className="text-base">{post.voterMRS} MRS</p>
                        </div>
                        <p className="text-center text-sm w-24">
                          Quadratic vote value
                        </p>
                      </div>

                      <div className="flex flex-col space-y-1 items-center">
                        <div className="py-2 px-4 bg-[#FFE999] rounded-xl">
                          <p className="text-base">{post.stakedMRS}/10 MRS</p>
                        </div>
                        <p className="text-center text-sm w-24">
                          Author staked value
                        </p>
                      </div>

                      <div className="flex flex-col space-y-1 items-center">
                        <div className="py-2 px-4 bg-[#FFE999] rounded-xl">
                          <p className="text-base">{post.validatorMRS} MRS</p>
                        </div>
                        <p className="text-center text-sm w-24">
                          Validator staked value
                        </p>
                      </div>

                      <div className="flex flex-col space-y-1 items-center">
                        <div className="py-2 px-4 bg-[#FFE999] rounded-xl">
                          <p className="text-base">
                            {post.accepted ? "Accepted" : "Not Accepted"}
                          </p>
                        </div>
                        <p className="text-center text-sm w-24">
                          Acceptance Status
                        </p>
                      </div>
                    </div>

                    <button
                      onClick={(e) => voteHandler(e, post._id)}
                      className="py-4 px-4 bg-[#39BC9F] mt-8 text-white rounded-xl shadow-lg"
                    >
                      Stake/Vote for this suggestion
                    </button>
                  </div>
                  <div className="bg-white flex flex-col shadow-lg rounded-b-lg py-4 px-8">
                    <div className="flex flex-row justify-between">
                      <p className="text-base">
                        {post.comments.length} Comments
                      </p>
                      {expanded && expanded[index] ? (
                        <div
                          className="font-xl cursor-pointer"
                          onClick={(e) => expansionHandler(e, index)}
                        >
                          <AiOutlineMinus />
                        </div>
                      ) : (
                        <div
                          className="font-xl cursor-pointer"
                          onClick={(e) => expansionHandler(e, index)}
                        >
                          <AiOutlinePlus />
                        </div>
                      )}
                    </div>
                    <div className="">
                      {expanded && expanded[index] && (
                        <div className="py-8 px-4 flex flex-col items-start">
                          <div className="flex flex-row mb-4 items-center">
                            <div className="bg-blue-500 rounded-full w-8 h-8"></div>
                            <p className="text-base ml-4">{uname}</p>
                          </div>
                          <textarea className="py-4 px-4 border border-black rounded w-full"></textarea>
                          <button
                            onClick={(e) => postComment(e, post._id)}
                            className="py-2 px-4 mt-4  text-white bg-[#39bc9f] rounded-2xl"
                          >
                            Add Comment
                          </button>
                        </div>
                      )}
                      {expanded &&
                        expanded[index] &&
                        post.comments &&
                        post.comments.map((comment) => {
                          return (
                            <div key={comment._id} className="py-8 px-4">
                              <div className="flex flex-row mb-4 items-center">
                                <div className="bg-blue-500 rounded-full w-8 h-8"></div>
                                <p className="text-base ml-4">
                                  {comment.uname}
                                </p>
                              </div>

                              <div
                                className="text-left"
                                dangerouslySetInnerHTML={{
                                  __html: comment.content,
                                }}
                              ></div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="flex justify-center items-center w-full h-96">
              <SpinningCircles fill="#000" />
            </div>
          )}

          <div className="px-8 py-8 text-left bg-[#f5f5f5]">
            <h2 className="font-xl mb-2  font-bold">Your Contribution</h2>
            <JoditEditor
              ref={editor}
              value={content}
              config={config}
              onBlur={(e) => handleUpdate(e)}
              onChange={(newContent) => {}}
            />
            {/* <div dangerouslySetInnerHTML={{__html:content}}/> */}
            <div className="h-[15rem] flex flex-col justify-evenly items-start my-8">
              <label>Select MRS token to stake</label>
              <input
                className="border p-4 border-black rounded-xl"
                type="number"
                step="0.0000001"
                max="10.00"
                min="0.00"
                onChange={(e) => alterStake(e)}
                value={stake}
              />
              <button
                onClick={publish}
                className="bg-blue-500 px-8 py-2 text-white rounded-2xl"
              >
                Stake and Publish
              </button>
            </div>
          </div>
        </div>
        <div className="m-4">
          {" "}
          <Wallet />{" "}
        </div>
      </div>
    </div>
  );
}

export default Suggestions;
